import { COMPANY_NAME_MAP } from '../company';
import { Industry, HeaderContent } from 'src/types';

import financeLogo from 'src/assets/images/logos/finance-logo.png';
import financeStyles from 'src/styles/finance/header.module.css';

import gamblingLogo from 'src/assets/images/logos/gambling-logo.png';
import gamblingStyles from 'src/styles/gambling/header.module.css';

import insuranceLogo from 'src/assets/images/logos/insurance-logo.png';
import insuranceStyles from 'src/styles/insurance/header.module.css';

import mobileLogo from 'src/assets/images/logos/mobile-logo.png';
import mobileStyles from 'src/styles/mobile/header.module.css';

import retailLogo from 'src/assets/images/logos/retail-logo.png';
import retailStyles from 'src/styles/retail/header.module.css';

export const HEADER_CONTENT_MAP: Record<Industry, HeaderContent> = {
  Finance: {
    cssStyles: financeStyles,
    logo: {
      src: financeLogo,
      alt: `${COMPANY_NAME_MAP['Finance']} Logo`,
    },
    logoText: COMPANY_NAME_MAP['Finance'],
    navLinks: ['Home', 'Credit Cards', 'Loans', 'Mortages', 'Investments'],
  },
  Gambling: {
    cssStyles: gamblingStyles,
    logo: {
      src: gamblingLogo,
      alt: `${COMPANY_NAME_MAP['Gambling']} Logo`,
    },
    navLinks: ['Casino', 'Slots', 'Poker', 'Bingo', 'About Us'],
  },
  Insurance: {
    cssStyles: insuranceStyles,
    logo: {
      src: insuranceLogo,
      alt: `${COMPANY_NAME_MAP['Insurance']} Logo`,
    },
    logoText: COMPANY_NAME_MAP['Insurance'],
    navLinks: ['Home', 'Health', 'Pet', 'Travel', 'Business'],
  },
  Mobile: {
    cssStyles: mobileStyles,
    logo: {
      src: mobileLogo,
      alt: `${COMPANY_NAME_MAP['Mobile']} Logo`,
    },
    logoText: COMPANY_NAME_MAP['Mobile'],
    navLinks: ['Mobile', 'Broadband', 'Tech', 'Upgradres', 'SIM only'],
  },
  Retail: {
    cssStyles: retailStyles,
    logo: {
      src: retailLogo,
      alt: `${COMPANY_NAME_MAP['Retail']} Logo`,
    },
    logoText: COMPANY_NAME_MAP['Retail'],
    navLinks: ['Home', 'Women', 'Men', 'Membership'],
  },
};
